import React, { useState, useEffect } from 'react'
import Header from '../../../Header/Header'
import Sidebar from '../../../Sidebar/Sidebar'
import Footer from '../../../Footer/Footer'
import Table from '../../../Table/Table'
import Thead from '../../../Table/Thead'
import Tbody from '../../../Table/Tbody'
import Tfoot from '../../../Table/Tfoot'
import StylePage from '../../../Style Page/StylePage'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import { search, changePage, get, order, change_qtd_per_page, changePesquisa, clearPesquisa } from './Actions/actions'
import { pagination } from '../../../Pagination/paginations'
import {Link} from 'react-router-dom'
import Pagination from '../../../Table/Pagination'
import Cabecalho from '../../../Table/Cabecalho'
import Alert from '../../../Alerts/Alert'
import ReactLoading from 'react-loading'
import { Content } from '../../../LoadingStyle/StyleLoading'
import ServiceTypes from './Areas'
import { changeStatus } from '../../../Services/area'



function GridServiceType(props) {
    const [ loading, setLoading ] = useState(false);
    const [ success, setSuccess ] = useState('');
    const [ error, setError ] = useState('');
    const nome = 'area_projetos.descricao'; 
    const gerente = 'area_projetos.id_gerente'
   
    const getAreas = () => {
        props.get();
    }

    useEffect(() => {
        getAreas()
        return () => {
            getAreas()
        }
    },[])

    const changeStatusActive = (event) =>{
        const id = event.target.id
        let checked = event.target.checked === true ? 1 : 0
        const data = {
            situacao:checked,     
        }

        changeStatus(id, data)
        .then(resp=> {
            setLoading(false)
            setError('')
            setSuccess(resp.data.success)
            getAreas()
            setTimeout(() => {
                setSuccess('')
            }, 2500);
        })
        .catch(e => {
            setLoading(false)
            setSuccess('')
            setError(e.response.data.error) 
        })
    }
     
    
    return (
        <div className="wrapper">
            <Header />
            <Sidebar />
            <StylePage>

                {loading === true ? (
                    <Content>
                        <ReactLoading type="spinningBubbles" color="blue" height={200} width={100} />
                    </Content>
                    
                ):('')}
                {success ? (
                    <Alert type="success">{success}</Alert>
                ):("")}
                {error ? (
                    <Alert type="danger">{error}</Alert>
                ):("")}
                <div style={{display: loading === true ? ('none'):('block')}}>

                    <Table 
                        view={
                            <div className="col-sm-12 col-md-5">
                                <div className="dataTables_info" id="example1_info" role="status" aria-live="polite">
                                    Exibindo de {props.from} à {props.to} do total de {props.qtd_total}
                                </div>
                            </div>
                        }
                            
                        cabecalho={
                            
                            <Cabecalho to="#/" action={props.search} clear={props.clearPesquisa} valuePesquisa={props.pesquisa} value={props.qtd_per_page} onChange={props.change_qtd_per_page} changePesquisa={props.changePesquisa} />
   
                        }
                        pagination={<Pagination>{props.pagination(props.current_page,props.get,props.last_page,props.changePage)}</Pagination>} title="Cadastro de Área"
                        button={
                           <Link to="/new_area" className="btn btn-primary">Cadastro</Link>
                            
                        }>
                        <Thead>
                            <th>STATUS</th>  
                            <th>NOME<Link to="/area" style={{float:'right'}} onClick={()=>props.order(nome)}><i className={`right fas fa-sort-amount-${props.th === 'area_projetos.descricao' ? (props.asc === true ?('down'):('up')):('down')}-alt`}></i></Link></th>
                            <th>GERENTE<Link to="/area" style={{float:'right'}} onClick={()=>props.order(gerente)}><i className={`right fas fa-sort-amount-${props.th === 'area_projetos.id_gerente' ? (props.asc === true ?('down'):('up')):('down')}-alt`}></i></Link></th>
                            <th>AÇÕES</th>
                        </Thead>
                        <Tbody>
                            <ServiceTypes area={props.areas} 
                            changeStatus={changeStatusActive}/>
                        </Tbody>
                        <Tfoot>
                            <th>STATUS</th>
                            <th>NOME</th>
                            <th>GERENTE</th>
                            <th>AÇÕES</th>
                        </Tfoot>
                    </Table>        
                </div>
            </StylePage>
            <Footer />
        </div>
    )
}

const mapStateToProps = state => ({
    areas:state.area.areas.data,
    current_page:state.area.areas.current_page,
    last_page:state.area.areas.last_page,
    from:state.area.areas.from,
    to:state.area.areas.to,
    qtd_total:state.area.areas.total,
    pesquisa:state.area.pesquisa, 
    qtd_per_page:state.area.qtd_per_page,
    asc:state.area.asc,
    th:state.area.th  
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
        pagination, 
        get, 
        order, 
        change_qtd_per_page, 
        changePesquisa, 
        clearPesquisa,
        changePage,
        search
    }, dispatch);

export default connect(mapStateToProps,mapDispatchToProps)(GridServiceType)
